import type { SVGProps } from 'react';

interface Props extends SVGProps<SVGSVGElement> {}

const RectangleArrowIcon = ({ ...props }: Props) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <rect
      x="4"
      y="4"
      width="40"
      height="40"
      rx="6"
      ry="6"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M24 12 L14 24 H20 V34 H28 V24 H34 L24 12 Z" fill="currentColor" />
  </svg>
);

export default RectangleArrowIcon;
